module.exports = __webpack_public_path__ + "static/img/bottom-d-right.dfa96e8c.png";